export default "__VITE_ASSET__Bjy$4Fjr__"